import React, { createContext, useMemo, useState } from 'react';

const AuthContextValue = {};
export const AuthContext = createContext(AuthContextValue);
export const ContextProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userToken, setUserToken] = useState(null);

  const value = useMemo(
    () => ({
      isAuthenticated,
      setIsAuthenticated,
      userToken,
      setUserToken,
    }),
    [isAuthenticated, userToken]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
